import { NetzTranslateService } from './../../../services/netz-translate.service';
import { ChangeDetectorRef, Component, forwardRef, Injector, Input } from '@angular/core';
import { RadioButtonGroupComponent } from '../radio-button-group/radio-button-group.component';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-radio-button-yes-no',
  templateUrl: '../radio-button-group/radio-button-group.component.html',
  styleUrls: ['../../styles/custom-control.styles.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioButtonYesNoComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RadioButtonYesNoComponent),
      multi: true,
    },
  ],
})
export class RadioButtonYesNoComponent extends RadioButtonGroupComponent {
  @Input() yesValue: any = true;
  @Input() noValue: any = false;

  constructor(private translationService: NetzTranslateService, inj: Injector, cd: ChangeDetectorRef) {
    super(inj);

    this.setOptions();
    this.preventLeak(this.translationService.registerForLanguageChange()).subscribe(() => this.setOptions());
  }

  private setOptions() {
    this.options = [
      { label: this.translationService.translateString('yes-button-label'), value: true },
      { label: this.translationService.translateString('no-button-label'), value: false },
    ];
  }

  ngOnInit(): void {
    this.initBase();
  }
}
